<template>
  <div class="setMealList">
    <div>
      <ul class="setMealListCon">
        <li
          v-for="item in data"
          :key="item.id"
          @click="checkMeal(item)"
          :class="{ checked: checked == item.id }"
        >
          <div class="ul1">
            <span v-if="Chinese">
              <img v-if="item.setmealType == 2" src="../images/En.png" />
              <img v-if="item.setmealType == 1" src="../images/Cn.png" />
            </span>
            <span v-if="!Chinese">
              <img v-if="item.setmealType == 1" src="../images/CNReport.png" />
              <img
                v-if="item.setmealType == 2"
                src="../images/ENReport33.png"
              />
            </span>

            <p >
              {{ item.setmealName.split('(')[1].split(')')[0] }}
            </p>
            <p v-if="!Chinese">
              {{ item.setmealEnname.split('(')[0] }}
            </p>
          </div>
          <div class="ul2">
            <p class="ul2-p1">
              <span >￥{{ item.setmealDiscountrmb }}</span>

              /
              <span>${{ item.setmealDiscountmy }}</span>
            </p>
            <!-- <p class="ul2-p2">
              (
              <span>￥{{ item.setmealOriginrmb }}</span
              >/
              <span>${{ item.setmealOriginmy }}</span>
              )
            </p> -->
          </div>
          <div class="right-bottom">
            <img src="../images/yes.png" />
          </div>
        </li>
      </ul>
      <div class="setMealList-button">
        <a-button style="background: #999;" v-if="(checked== 1|| checked==2) && isFirst!=0">{{
          $tc('lang.UserCenter.Check_out_now')
        }}</a-button>
        <a-button   type="primary" @click="action(checked)" v-else>{{
          $tc('lang.UserCenter.Check_out_now')
        }}</a-button>
      </div>
    </div>
    <!-- <a-table
      :columns="columns"
      :dataSource="data"
      :scroll="{ y: 'calc(100vh - 380px)' }"
      :locale="{
        emptyText: $tc('lang.No_data'),
      }"
      :loading="loading"
      rowKey="personId"
      :pagination="{
        total: total,
        current: page,
        pageSize: size,
        onChange: onChangePage,
      }"
    >
      <a-button
        style="background: #FF8D1A;border: 1px solid #FF8D1A"
        slot="action"
        type="primary"
        slot-scope="record"
        @click="action(record)"
        size="small"
        >{{ $tc('lang.UserCenter.Check_out_now') }}</a-button
      >
    </a-table> -->
  </div>
</template>
<script>
// import modeOfPayment from '../../../views/pay/modeOfPayment';

export default {
  data() {
    return {
      data: [],
      page: 1,
      size: 10,
      total: 10,
      loading: true,
      user: {},
      Chinese: '',
      checked: null,
      isFirst:0
    };
  },
  created() {
    this.querySetmeal();
    this.getFirst();

    // 获取用户session信息
    this.user = JSON.parse(sessionStorage.getItem('user')) || {};
    //判断当前语言环境
    if (this.$i18n.locale === 'zh-CN') {
      this.Chinese = true;
    } else if (this.$i18n.locale === 'en-US') {
      this.Chinese = false;
    }
  },
  computed: {
    language() {
      return this.$i18n.locale;
    },
    // columns() {
    //   return [
    //     {
    //       title: this.$tc('lang.UserCenter.Item_Nr'),
    //       align: 'center',
    //       width: 80,
    //       customRender: (text, record, index) => `${index + 1}`,
    //     },
    //     {
    //       title: this.$tc('lang.UserCenter.Package'),
    //       dataIndex: this.Chinese == true ? 'setmealName' : 'setmealEnname',
    //       key: this.Chinese == true ? 'setmealName' : 'setmealEnname',
    //       width: 160,
    //       align: 'center',
    //     },
    //     {
    //       title: this.$tc('lang.UserCenter.Original_rem'),
    //       dataIndex: 'setmealOriginrmb',
    //       key: 'setmealOriginrmb',
    //       width: 120,
    //       align: 'center',
    //     },
    //     {
    //       title: this.$tc('lang.UserCenter.Original_ub'),
    //       key: 'setmealOriginmy',
    //       dataIndex: 'setmealOriginmy',
    //       width: 120,
    //       align: 'center',
    //     },
    //     {
    //       title: this.$tc('lang.UserCenter.Package_Price_rem'),
    //       key: 'setmealDiscountrmb',
    //       dataIndex: 'setmealDiscountrmb',
    //       width: 120,
    //       align: 'center',
    //     },
    //     {
    //       title: this.$tc('lang.UserCenter.Package_Price_ub'),
    //       key: 'setmealDiscountmy',
    //       dataIndex: 'setmealDiscountmy',
    //       width: 120,
    //       align: 'center',
    //     },
    //     {
    //       title: this.$tc('lang.UserCenter.Total_MD'),
    //       key: 'setmealCount',
    //       dataIndex: 'setmealCount',
    //       width: 120,
    //       align: 'center',
    //     },
    //     {
    //       title: this.$tc('lang.UserCenter.Operate'),
    //       key: 'action',
    //       scopedSlots: { customRender: 'action' },
    //       width: 100,
    //       align: 'center',
    //     },
    //   ];
    // },
  },
  watch: {
    language() {
      if (this.language === 'zh-CN') {
        this.Chinese = true;
      } else if (this.language === 'en-US') {
        this.Chinese = false;
      }
    },
  },
  methods: {
    getFirst(){
      // 获取用户session信息
      this.user = JSON.parse(sessionStorage.getItem('user')) || {};
      this.$http
        .post('/hzwmj/person-setmealpay/getMealPay', {
          // params: {
          personId: this.user.id,
          page: this.page,
          size: this.size,
          // },
        })
        .then(data => {
          if (data.code === 200) {
            const buyData = data.data;
            const ndata = buyData.records;
           this.isFirst = ndata.length
           console.log(this.isFirst)
          } else if (data.code === 900) {
            this.$message.error(data.msg);
          } else {
            this.$message.error('系统异常');
          }
        })
        .catch(() => {
         
        });
    },
    action(value) {
      console.log(value);
      this.$router.push({
        path: '/pay',
        query: {
          // id: value.id,
          id: value,
          type: 1,
        },
      });
      // this.$nextTick(() => {
      //   this.$refs.modeOfPayment.init(value);
      // });
    },
    // 切换页码
    onChangePage(page) {
      this.page = page;
      this.querySetmeal();
    },
    //选择套餐
    checkMeal(value) {
      this.checked = value.id;
    },
    // 表格请求
    querySetmeal() {
      this.$http
        .get('/hzwmj/setmeal/list', {
          params: {
            page: this.page,
            size: this.size,
          },
        })
        .then(data => {
          if (data.code === 200) {
            const buyData = data.data;
            this.data = buyData.records;
            this.total = buyData.total;
            this.loading = false;
          } else if (data.code === 900) {
            this.$message.error(data.msg);
          } else {
            this.$message.error('系统异常');
          }
        })
        .catch(() => {
          this.data = [];
          this.total = 0;
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="less">
.setMealList {
  li {
    list-style: none;
  }
  .setMealListCon {
    width: 875px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    // justify-content: flex-start;
    p {
      margin-bottom: 0;
    }

    li {
      width: 260px;
      text-align: center;
      border: 1px solid #d8d8d8;
      padding: 10px;
      height: 290px;
      margin-bottom: 20px;
      position: relative;
      .ul1 {
        height: 145px;
        border-bottom: 1px dashed #d6d6d6;
        img {
          width: 122px;
          margin: 40px 0 10px 0;
        }
        p {
          font-size: 20px;
        }
      }
      .ul2 {
        height: 145px;
        .ul2-p1 {
          color: #daaa63;
          font-size: 26px;
          margin: 40px 0 10px 0;
        }
        .ul2-p2 {
          color: #686565;
          font-size: 18px;
          text-decoration: line-through;
        }
      }
      .right-bottom {
        display: none;
        position: absolute;
        bottom: -1px;
        right: -1px;
      }
    }
    .checked {
      border: 2px solid #d49c4a;
      .right-bottom {
        display: block;
      }
    }
  }
  .setMealList-button {
    text-align: center;
  }
}
</style>
